import { $Q } from '../utils/query-selector';

(function confirmPass() {
    const createCustomer = $Q('#create_customer');

    if (!createCustomer) return;

    createCustomer.addEventListener('submit', (e) => {
      if ($Q('input[name="customer[password]"]').value !== $Q('input[name="customer[password_confirmation]"]').value) {
        const errorContainer = $Q('#error-container');
        errorContainer.innerHTML = `<small class="form__message" tabindex="-1">
          <svg aria-hidden="true" focusable="false" role="presentation">
            <use href="#icon-error"/>
          </svg>
          ${errorContainer.getAttribute('error-heading')}
        </small>
        <ul>
          <li>
            ${errorContainer.getAttribute('error-confirmation')}
          </li>
        </ul>`
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
}());
